import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Css/Menubar.css";
import { AppContext } from "../../context/AppContext";
import SearchBar from "./SearchBar";
import MetaTag from "./MetaTag";

const MenuBar = () => {
  const [menuList, setmenuList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { baseUrl, setgamelist, setdescreption, setmetadata } =
    useContext(AppContext);
  const [meta, setMeta] = useState({
    title: "",
    keywords: "",
    descreption: "",
  });
  useEffect(() => {
    handleSubmit();
  }, []);

  const fetchData = async (menu) => {
    try {
      const res = await axios.get(
        `${baseUrl}/getGameBymenuroute/${menu.route}`
      );
      if (res) {
        console.log("Fetched game list:", res.data.games);
        const allGames = res.data.games || [];
        console.log("Fetched game list:", allGames);

        // normalize comparison
        const route = menu.route.toLowerCase();

        // sort so matching categories (case-insensitive) come first
        let menuIdList = [];
        const sortedGames = [
          ...allGames.filter((game) => {
            //menuIdList.push(game.id);
            return game.category?.toLowerCase() === route;
          }),
          ...allGames.filter((game) => {
            menuIdList.push(game.id);
            return game.category?.toLowerCase() !== route;
          }),
        ];
        console.log("sortedGames game list:", sortedGames);

        if (allGames.length < 30) {
          const res = await axios.get(`${baseUrl}/get-game-list`);
          const allGamesList = res.data.getAllGame || [];

          const additionalGames = allGamesList.filter(
            (game) => !menuIdList.includes(game.id)
          );

          const combinedGames = [...sortedGames, ...additionalGames];
          console.log("combinedGames game list:", combinedGames);
          setgamelist(combinedGames);
        } else {
          setgamelist(allGames);
        }

        //setgamelist(sortedGames);
        // setgamelist(res.data.games);
      } else {
        console.error("Failed to fetch game list:", res);
      }
    } catch (err) {
      console.error("Error fetching game list:", err);
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.get(`${baseUrl}/get-menus`);
      if (response) {
        setmenuList(response.data.data);
      }
    } catch (error) {
      console.error("Error saving menuList:", error);
    }
  };
  const setmetadataformenu = async (menu) => {
    try {
      const response = await axios.get(
        `${baseUrl}/getgame-categorywise/${menu.name}`
      );
      if (response) {
        // setgamelist(response.data.data);
        //setCategory(response.data.data);
      }
      const menucatdata = await axios.get(
        `${baseUrl}/getgame-bycategoryname/${menu.name}`
      );
      if (menucatdata) {
        let catDes = menucatdata.data.data.description;
        setMeta({
          title: menucatdata.data.data.meta_title,
          keywords: menucatdata.data.data.meta_keyword,
          descreption: menucatdata.data.data.meta_description,
        });

        const titleTag = document.querySelector("head > title");
        titleTag.textContent = menucatdata.data.data.meta_title;

        setdescreption(catDes);
      }
    } catch (error) {
      //console.error('Error saving category:', error);
    }
  };

  return (
    <nav className="menu-bar">
      {/* Hamburger button (only visible on mobile) */}
      {meta.title && meta.keywords && (
        <MetaTag
          title={meta.title}
          keywords={meta.keywords}
          descreption={meta.descreption}
        />
      )}
      <div className="main_menu">
        <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          ☰
        </div>
        <div className="menu-item mobile_logo">
          <Link to="/">
            <img
              src="/logo.svg"
              alt="Logo"
              style={{ width: "100px" }}
              className="menu-logo"
            />
          </Link>
        </div>
        <div className="searchbar_mobile">
          <SearchBar />
        </div>
      </div>
      {/* Menu List */}
      <div className="menu_main_desktop">
        <ul className={`menu-list ${isOpen ? "active" : ""}`}>
          {/* <li key="all_game" className="menu-item" onClick={() => fetchData()}>
          <Link style={{ color: "white", textDecoration: "none" }} to={`/`} onClick={() => setIsOpen(false)}>
            Home
          </Link>
        </li> */}
          <li className="desktop_logo">
            <Link to="/">
              <img
                src="/logo.svg"
                alt="Logo"
                style={{ width: "100px" }}
                className="menu-logo"
              />
            </Link>
          </li>
          {menuList.map((menu) => (
            <li key={menu.id} className="menu-item">
              <Link
                style={{ color: "white", textDecoration: "none" }}
                to={`/menu/${menu.route}`}
                onClick={() => {
                  setmetadataformenu(menu);
                  fetchData(menu);

                  setIsOpen(false);
                }}
              >
                {menu.name.charAt(0).toUpperCase() + menu.name.slice(1)}
              </Link>
            </li>
          ))}
          <li className="menu-item">
            <Link
              style={{ color: "white", textDecoration: "none" }}
              to={`/blog`}
            >
              Blog
            </Link>
          </li>
        </ul>
        <div className="searchbar_desktop">
          <SearchBar />
        </div>
      </div>
    </nav>
  );
};

export default MenuBar;
